// extracted by mini-css-extract-plugin
export var fullWidthButton = "_rr-0";